// Counts characters, not UTF-16 units, so a cut never splits an emoji in half.
export const truncate = (text: string, maxLength: number) => {
  const characters = [...text]
  if (characters.length <= maxLength) return text
  // The ellipsis takes one of the characters we are allowed, so a limit under 2 leaves only itself.
  return `${characters
    .slice(0, Math.max(0, maxLength - 1))
    .join('')
    .trimEnd()}…`
}
